import * as Sentry from "@sentry/react";

export function initSentry() {
  // Solo en producción
  if (import.meta.env.MODE !== 'production') {
    console.log('🔴 Sentry disabled in development');
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    
    // Integrations
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: 0.1, // 10% de transacciones
    
    // Session Replay (video de lo que hizo el usuario)
    replaysSessionSampleRate: 0.1, // 10% de sesiones
    replaysOnErrorSampleRate: 1.0, // 100% cuando hay error

    // Environment
    environment: import.meta.env.MODE,

    // Release tracking
    release: import.meta.env.VITE_APP_VERSION || 'unknown',

    // Filtrar errores conocidos
    beforeSend(event, hint) {
      // Ignorar errores de extensiones del navegador
      if (event.exception) {
        const error = hint.originalException;
        if (error && error.message && error.message.includes('chrome-extension://')) {
          return null;
        }
      }
      return event;
    },
  });
}

// Helper para setear contexto de usuario
export function setSentryUser(user) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.uid,
    email: user.email,
    username: user.displayName,
  });
}

// Helper para capturar errores manualmente
export function captureError(error, context = {}) {
  Sentry.captureException(error, {
    contexts: {
      custom: context,
    },
  });
}

// Helper para breadcrumbs (historial de acciones)
export function addBreadcrumb(message, category = 'user-action', data = {}) {
  Sentry.addBreadcrumb({
    message,
    category,
    data,
    level: 'info',
  });
}